import { createWidget } from "@squeletteapp/widget-builder";
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "@babackapp/ui/components/sidebar";
import { RotateCcw } from "lucide-react";
import { useEffect, useRef } from "react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

const RETURN_WIDGET_BASE_URL = `${import.meta.env.VITE_URL}/return-widget`;

export function RetractionPortalButton() {
  const { data: shop } = useCurrentShopSuspense();
  const widgetRef = useRef<ReturnType<typeof createWidget> | null>(null);

  useEffect(() => {
    const source = `${RETURN_WIDGET_BASE_URL}/${shop.providerId}`;
    widgetRef.current = createWidget({
      elementName: "retraction-portal-widget",
      source,
      position: "s",
      overlay: true,
      animation: "slide-spring",
      style: { width: "520px", height: "80vh", borderRadius: "12px" },
    });
    widgetRef.current.preload();

    // TODO: cet reset est peut etre pas ideal pour shopnow, a verifier
    widgetRef.current.onOpenChange((isOpen) => {
      if (!isOpen) widgetRef.current?.setSource(source);
    });

    return () => {
      widgetRef.current = null;
    };
  }, []);

  return (
    <SidebarMenuItem>
      <SidebarMenuButton onClick={() => widgetRef.current?.open()}>
        <RotateCcw className="w-4 h-4" />
        <span>Nouvelle retractation</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
